import { render } from "./PartnerCategoriesTable.vue?vue&type=template&id=1b257392"
import script from "./PartnerCategoriesTable.vue?vue&type=script&lang=js"
export * from "./PartnerCategoriesTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__